import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'situacao'
})
export class SituacaoPipe implements PipeTransform {
  transform(value: number | null | undefined): {
    text: string;
    className: string | null;
  } {
    if (value === null || value === undefined) {
      return { text: '—', className: null };
    }

    switch (value) {
      case 1:
        return {
          text: 'Bloqueado',
          className: 'status-bloqueado'
        };
      case 2:
        return {
          text: 'Supervisão',
          className: 'status-supervisao'
        };
      case 3:
        return {
          text: 'Encerrado',
          className: 'status-encerrado'
        };
      default:
        return {
          text: 'Encerrado',
          className: null
        };
    }
  }
}
